import script from "./AllList.vue?vue&type=script&setup=true&lang=js"
export * from "./AllList.vue?vue&type=script&setup=true&lang=js"

import "./AllList.vue?vue&type=style&index=0&id=0127f29b&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0127f29b"]])

export default __exports__